export enum SensitivityLevel {
    Low = 'Low',
    Medium = 'Medium',
    High = 'High'
  }